import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "./Layout";
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import { saveAs } from "file-saver";
import "dayjs/locale/ja";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import googleAnalytics from "fuction/googleAnalytics";
dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  subtitle: {
    marginLeft: "5px",
  },
  datePicker: {
    width: "105px",
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  dlbtn: {
    paddingTop:"16px",
    paddingLeft:"10px",
  },
}));

export default function DataDownload(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);
  const [isdisable, setIsdisable] = React.useState(true);

  const messages = message();
  const maxDate = dayjs();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Media - データダウンロード";
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  const handleRange = () => {
    fetchCsv("range", {
      range: [
        dayjs(fromDate).format("YYYY-MM-DD"),
        dayjs(toDate).format("YYYY-MM-DD"),
      ],
    });
  };

  const fetchCsv = (fileName, params) => {
    if (auth.state.activeMediaGroup === 0) {
      return;
    }

    const groupName = auth.state.mediaGroups.find(
      (group) => auth.state.activeMediaGroup === group.id
    ).name;
    request({
      method: "GET",
      url: `data/:account_id/media/download/${
        auth.state.activeMediaGroup
      }?${convertQueryParam(params)}`,
      responseType: "blob",
      headers: { Accept: "application/csv" },
    }).then((data) => {
      const blob = new Blob([data], {
        type: "application/csv",
      });
      // データがあればcsvダウンロード
      if (blob.size > 0) {
        saveAs(blob, 
          `${groupName}-${(params.range[0]).replace(/-/g, "")}-` + 
          `${(params.range[1]).replace(/-/g, "")}.csv`
        );
      } else {
        alert(messages.errorMsg.blobSizeZero);
      }
    });
  };

  const dateValidation = (date, type) => {
    // 入力内容が日付として正しいかチェック
    if (dayjs(date, "YYYY/MM/DD").isValid()) {
      if (type == "from") {
        if (toDate) {
          const toDateTime = dayjs(toDate).format("YYYY-MM-DD 00:00:00")
          const selectedDateTime = dayjs(date).format("YYYY-MM-DD 00:00:00")
          // 終了日付が開始日付より後の日かチェック
          if ((dayjs(toDateTime).isSameOrAfter(dayjs(selectedDateTime)))){
            setFromDate(dayjs(date));
            setIsdisable(false);
          } else {
            alert(messages.validation.dateRang);
          }
        } else {
          setFromDate(dayjs(date));
        }
      } else if (type == "to"){
        if (fromDate) {
          const fromDateTime = dayjs(fromDate).format("YYYY-MM-DD 00:00:00")
          const selectedDateTime = dayjs(date).format("YYYY-MM-DD 00:00:00")
          // 開始日付が終了日付より前の日かチェック
          if ((dayjs(fromDateTime).isSameOrBefore(dayjs(selectedDateTime)))) {
            setToDate(dayjs(date));
            setIsdisable(false);
          } else {
            alert(messages.validation.dateRang);
          }
        } else {
          setToDate(dayjs(date));
        }
      }

      if (toDate && fromDate) {
        setIsdisable(false);
      }
      return;
    }
    setIsdisable(true);
    return;
  }

  const dateError = (error, value) => {
    if (error) {
      setIsdisable(true);
    }
    return;
  }

  return (
    <Layout
      content={
        <Grid container spacing={3}>
          <List>
            <ListItem>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography variant="h6">
                      期間を指定
                    </Typography>
                    <Typography variant="subtitle2" className={classes.subtitle}>
                      ※期間内のデータを1ファイルで作成しダウンロードできます。
                    </Typography>
                  </React.Fragment>
                }
                secondary={
                  <React.Fragment>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container alignItems="baseline">
                        <DatePicker
                          format="yyyy/MM/dd"
                          margin="normal"
                          value={fromDate}
                          maxDate={maxDate}
                          maxDateMessage={
                            (messages.validation.maxDate).replace(
                              "$1", 
                              maxDate.format("YYYY-MM-DD")
                            )
                          }
                          onError={(error, value) => dateError(error, value)}
                          onChange={(date) => dateValidation(date, "from")}
                          className={classes.datePicker}
                        />
                        <div className={classes.divider}>〜</div>
                        <DatePicker
                          format="yyyy/MM/dd"
                          margin="normal"
                          value={toDate}
                          maxDate={maxDate}
                          maxDateMessage={
                            (messages.validation.maxDate).replace(
                              "$1",
                              maxDate.format("YYYY-MM-DD")
                            )
                          }
                          onError={(error, value) => dateError(error, value)}
                          onChange={(date) => dateValidation(date, "to")}
                          className={classes.datePicker}
                        />
                        <div className={classes.dlbtn}>
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            disabled={isdisable}
                            onClick={handleRange}
                          >
                            ダウンロード
                          </Button>
                        </div>
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </React.Fragment>
                }
              />
            </ListItem>
          </List>
        </Grid>
      }
    />
  );
}
